import { struct, UnknownRecord } from 'io-ts/Decoder';

export const Request = struct({
	data: struct({
		requirements: UnknownRecord,
		ancillaryItems: UnknownRecord,
	}),
});
